import type { AppDirectClient } from '../client.js';
import { AuthError } from '../errors.js';
import { getUserFromFeJwt } from '../session/jwt.js';
import type { AuthUser, ResolvedConfig } from '../types.js';

export async function assertConfiguredApplicationAssignment(
  config: ResolvedConfig,
  client: AppDirectClient,
  fejwt: string,
  user?: AuthUser | null,
): Promise<void> {
  if (config.applicationId == null) return;

  const fromJwt = getUserFromFeJwt(fejwt);
  let resolvedUser = user ?? fromJwt;
  if (
    resolvedUser?.id &&
    !resolvedUser.companyId &&
    fromJwt?.companyId &&
    fromJwt.id === resolvedUser.id
  ) {
    resolvedUser = { ...resolvedUser, companyId: fromJwt.companyId };
  }
  if (!resolvedUser?.id) {
    throw new AuthError('unauthorized', 'Unable to resolve user for application assignment');
  }
  if (!resolvedUser.companyId) {
    throw new AuthError('unauthorized', 'Missing company from session');
  }

  await client.assertUserAssignedToApplication({
    fejwt,
    companyUuid: resolvedUser.companyId,
    userUuid: resolvedUser.id,
    applicationId: config.applicationId,
  });
}
